import type { ReactNode } from "react";
import { Box, Container, Stack } from "@bookingcom/bui-react";
import { HeaderLogo } from "./HeaderLogo";

export const HeaderLayout = ({ actions }: { actions?: ReactNode }) => (
  <Box tagName="header" backgroundColor="brand_primary" padding={0}>
    <Container>
      <Box padding={0}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mixin={{ minHeight: 13, paddingBlockStart: 4, paddingBlockEnd: 4 }}
        >
          <HeaderLogo />
          {actions}
        </Stack>
      </Box>
    </Container>
  </Box>
);
